import "./Header.css";
import { Box, Typography } from "@mui/material";

export default function Header({ lastUpdate }) {
  return (
    <Box className="dashboard-header">
      <Box className="dashboard-header-inner">
        <Typography className="title">Satış statistikası</Typography>

        <Typography className="subtitle">
          Plan: <span className="bold">Basic</span> • Yenilənmə: {lastUpdate ? (() => {
            const d = new Date(lastUpdate);
            return `${d.toLocaleDateString("az-AZ")} / ${d.toLocaleTimeString("az-AZ")}`;
          })() : "-"}
        </Typography>
      </Box>
    </Box>
  );
}
